













































































































































































































import CommitResetBar from "@/components/data/commit-reset-bar.vue";
import Card from "@/components/layout/card.vue";
import Page from "@/components/layout/page.vue";
import PageHeader from "@/components/navigation/page-header.vue";
import TabsUser from "@/components/tabs/user.vue";
import { Committable, WrapService } from "@/plugins/committable";
import { userService } from "@/services/user";
import { User } from "@/swagger/models";
import { OktaUser, OktaUserStatus } from "@/types/okta";
import { UserRole, UserRoleDisplay } from "@/types/roles";
import { subject } from "@casl/ability";
import Vue from "vue";
import Component from "vue-class-component";

// See https://github.com/kaorun343/vue-property-decorator for all options

@Component({
    name: "user",
    components: { TabsUser, PageHeader, Card, CommitResetBar, Page },
})
export default class UserView extends Vue {
    committable: Committable<User>;
    OktaUserStatus = OktaUserStatus;

    selectedUserRole: UserRole = UserRole.user;
    activateNewUser: boolean = true;

    // nextId: number = null;
    // previousId: number = null;

    async created() {
        try {
            this.committable = new Committable<User>({
                onCommit: this.save.bind(this),
            });

            if (this.$route.params.userId === "new") {
                this.committable.set(
                    userService.build({
                        customerId: parseInt(this.$route.params.customerId),
                    }),
                );
            } else {
                await this.loadUser();
            }
        } catch (e) {
            console.warn(e);
            await this.$router.back();
        }
    }

    async loadUser() {
        const res = await userService.getNew(parseInt(this.$route.params.userId));
        this.committable.set(res.data);
        this.selectedUserRole = (res.data.okta as OktaUser).profile.userType as UserRole;
        // this.previousId = res.previousId;
        // this.nextId = res.nextId;
    }

    async save() {
        const oldRole = (this.committable.original.value.okta as OktaUser)?.profile?.userType;
        // console.log("Updating role:", oldRole, "->", this.selectedUserRole);

        const extraFields: Record<string, any> = { includeOktaInfo: true };

        if (this.$route.params.userId === "new") {
            extraFields.activate = this.activateNewUser;
            extraFields.customer = parseInt(this.$route.params.customerId);
        }

        // @ts-ignore (maxReservations is object in swagger model)
        let saveResult = await WrapService(userService, {
            extraFields,
            patchFields: ["firstName", "lastName", "customerId"],
            routeIdParam: "userId",
            router: this.$router,
        })(this.committable.clone.value);

        // Did the role change? Update it
        if (oldRole !== this.selectedUserRole) {
            await userService.setRole(saveResult.id, this.selectedUserRole);
            this.$nextTick(this.loadUser.bind(this));
        }

        return saveResult;
    }

    get roles() {
        const roles = [
            // Hid some as they are not used at the moment
            { label: UserRoleDisplay.wbAdmin, value: UserRole.wbAdmin },
            { label: UserRoleDisplay.customerAdmin, value: UserRole.customerAdmin },
            // { label: UserRoleDisplay.customerManager, value: UserRole.customerManager },
            // { label: UserRoleDisplay.customerReceptionist, value: UserRole.customerReceptionist },
            { label: UserRoleDisplay.customerViewer, value: UserRole.customerViewer },
            { label: UserRoleDisplay.user, value: UserRole.user },
        ];

        // Return only the ones that the user is allowed to assign, unless the user has a role already
        return roles.filter(
            (r) =>
                // @ts-ignore
                this.$can("update", "UserRole", r.value) ||
                (this.committable.original.value?.okta as OktaUser)?.profile.userType === r.value,
        );
    }

    get canEdit() {
        if (this.committable.loading.value) return false;
        // @ts-ignore
        if (this.$route.params.userId === "new" && this.$can("create", "User")) return true;
        // @ts-ignore
        else if (this.$can("update", subject("User", this.committable?.original?.value))) return true;
        return false;
    }

    get dirtyRole() {
        const oldRole = (this.committable.original.value.okta as OktaUser)?.profile?.userType;
        return oldRole !== this.selectedUserRole;
    }

    async activate(activate: boolean) {
        try {
            await userService.activate(this.committable.original.value.id, activate);
            await this.loadUser();
        } catch (e) {}
    }

    async resetPassword() {
        try {
            await userService.resetPassword(this.committable.original.value.id);
            await this.loadUser();
        } catch (e) {}
    }

    async suspend(suspend: boolean) {
        try {
            await userService.suspend(this.committable.original.value.id, suspend);
            await this.loadUser();
        } catch (e) {}
    }

    async unlock() {
        try {
            await userService.unlock(this.committable.original.value.id);
            await this.loadUser();
        } catch (e) {}
    }

    async deleteUser() {
        if (!confirm(`Are you sure you want to delete this user? This can not be undone.`)) return;
        try {
            await userService.delete(this.committable.original.value.id);
            await this.$router.replace({ name: "users" });
        } catch (e) {}
    }
}
